import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PatientProfileOverviewCard from '../shared/PatientProfileOverviewCard/PatientProfileOverviewCard';
import { GENETIC_COUNSELING_TRANSLATION } from '../../constants';
import { PatientContactAttemptCardProps } from './PatientContactAttemptedCard.types';

const PatientContactAttemptedCard: FC<PatientContactAttemptCardProps> = ({ contactAttemptInfo }) => {
  const { t } = useTranslation([GENETIC_COUNSELING_TRANSLATION]);

  return (
    <PatientProfileOverviewCard
      title={t('contact_attempt.counseling_status_card.title')}
      mainInfo={[
        {
          id: 'attempted-contact-date',
          label: t('contact_attempt.counseling_status_card.attempted_contact_date'),
          value: contactAttemptInfo.contactDate,
        },
      ]}
      notes={contactAttemptInfo?.notes}
    />
  );
};

export default PatientContactAttemptedCard;
